import axios from 'axios';
import { useQuery } from 'react-query';
import { FiltersType } from '../api/responses';

export const useGetFilters = () => {
    const getFilters = async (): Promise<FiltersType> => {
        const filters = await axios
            .get(`${process.env.REACT_APP_API_URL}/cases/filters/`)
            .then((res) => res.data);
        return filters;
    };
    const { data, isLoading, isError, error } = useQuery({
        queryKey: ['get-filters'],
        queryFn: getFilters,
        keepPreviousData: true,
        staleTime: Infinity,
        retry: 3
    });

    return { data, isError, isLoading, error };
};
